"use strict";
// Generated by robots, do not change this manually!
Object.defineProperty(exports, "__esModule", { value: true });
exports.light = void 0;
exports.light = {
    ":root": {
        "--plasma-colors-white": "rgba(255, 255, 255, 0.96)",
        "--plasma-colors-white-primary": "rgba(255, 255, 255, 0.96)",
        "--plasma-colors-white-secondary": "rgba(255, 255, 255, 0.56)",
        "--plasma-colors-white-tertiary": "rgba(255, 255, 255, 0.28)",
        "--plasma-colors-black": "#080808",
        "--plasma-colors-black-primary": "#080808",
        "--plasma-colors-black-secondary": "rgba(8, 8, 8, 0.56)",
        "--plasma-colors-black-tertiary": "rgba(8, 8, 8, 0.28)",
        "--plasma-colors-dark01": "#171717",
        "--plasma-colors-dark02": "#232323",
        "--plasma-colors-dark03": "#363636",
        "--plasma-colors-transparent": "rgba(0, 0, 0, 0)",
        "--plasma-colors-button-clear": "rgba(0, 0, 0, 0)",
        "--plasma-colors-button-black": "#080808",
        "--plasma-colors-button-black-secondary": "rgba(8, 8, 8, 0.12)",
        "--plasma-colors-button-black-transparent": "rgba(8, 8, 8, 0.56)",
        "--plasma-colors-button-white": "#FFFFFF",
        "--plasma-colors-button-white-secondary": "rgba(255, 255, 255, 0.12)",
        "--plasma-colors-text": "#080808",
        "--plasma-colors-link": "#2A72F8",
        "--plasma-colors-link-hover": "#4D89F9",
        "--plasma-colors-link-active": "#0859F1",
        "--plasma-colors-link-visited": "#2364DE",
        "--plasma-colors-link-visited-hover": "#427AE3",
        "--plasma-colors-link-visited-active": "#1C54BC",
        "--plasma-colors-primary": "#080808",
        "--plasma-colors-secondary": "rgba(8, 8, 8, 0.56)",
        "--plasma-colors-tertiary": "rgba(8, 8, 8, 0.28)",
        "--plasma-colors-paragraph": "rgba(8, 8, 8, 0.8)",
        "--plasma-colors-inverse": "rgba(255, 255, 255, 0.96)",
        "--plasma-colors-background": "#FFFFFF",
        "--plasma-colors-background-primary": "#FFFFFF",
        "--plasma-colors-background-secondary": "#FFFFFF",
        "--plasma-colors-background-tertiary": "#FFFFFF",
        "--plasma-colors-input-border": "rgba(0, 0, 0, 0)",
        "--plasma-colors-input-border-hover": "rgba(0, 0, 0, 0)",
        "--plasma-colors-input-border-focus": "rgba(0, 0, 0, 0)",
        "--plasma-colors-input-error-background": "rgba(243, 27, 48, 0.12)",
        "--plasma-colors-accent": "#296AE3",
        "--plasma-colors-success": "#0D8523",
        "--plasma-colors-warning": "#D14D00",
        "--plasma-colors-critical": "#E31227",
        "--plasma-colors-surface-liquid01": "rgba(8, 8, 8, 0.02)",
        "--plasma-colors-surface-liquid02": "rgba(8, 8, 8, 0.06)",
        "--plasma-colors-surface-liquid03": "rgba(8, 8, 8, 0.12)",
        "--plasma-colors-surface-solid01": "#FAFAFA",
        "--plasma-colors-surface-solid02": "#F0F0F0",
        "--plasma-colors-surface-solid03": "#E1E1E1",
        "--plasma-colors-surface-card": "#FFFFFF",
        "--plasma-colors-button-primary": "#2A72F8",
        "--plasma-colors-button-primary-hover": "#447ff9",
        "--plasma-colors-button-primary-active": "#2868e0",
        "--plasma-colors-button-secondary": "rgba(8, 8, 8, 0.06)",
        "--plasma-colors-button-secondary-hover": "rgba(8, 8, 8, 0.04)",
        "--plasma-colors-button-secondary-active": "rgba(8, 8, 8, 0.08)",
        "--plasma-colors-button-accent": "#296AE3",
        "--plasma-colors-button-success": "#148F2B",
        "--plasma-colors-button-success-transparent": "rgba(20, 143, 43, 0.3)",
        "--plasma-colors-button-success-hover": "#379740",
        "--plasma-colors-button-success-active": "#157e26",
        "--plasma-colors-button-success-active-transparent": "rgba(21, 126, 39, 0.35)",
        "--plasma-colors-button-warning": "#E35502",
        "--plasma-colors-button-warning-transparent": "rgba(227, 85, 2, 0.3)",
        "--plasma-colors-button-warning-hover": "#f76d2f",
        "--plasma-colors-button-warning-active": "#de550a",
        "--plasma-colors-button-warning-active-transparent": "rgba(222, 85, 10, 0.35)",
        "--plasma-colors-button-critical": "#F31B30",
        "--plasma-colors-button-critical-transparent": "rgba(243, 27, 48, 0.3)",
        "--plasma-colors-button-critical-hover": "#f53b46",
        "--plasma-colors-button-critical-active": "#dc1b2b",
        "--plasma-colors-button-critical-active-transparent": "rgba(220, 27, 43, 0.35)",
        "--plasma-colors-button-checked": "#080808",
        "--plasma-colors-button-checked-hover": "#080808",
        "--plasma-colors-button-checked-hover-color": "hsla(0, 0%, 100%, 0.9599999785423279)",
        "--plasma-colors-button-checked-active": "#080808",
        "--plasma-colors-button-checked-active-color": "hsla(0, 0%, 100%, 0.9599999785423279)",
        "--plasma-colors-button-focused": "#296AE3",
        "--plasma-colors-gradient": "linear-gradient(45deg, hsla(219.87577639751552, 100%, 68.43137254901961%, 1) 0%, hsla(190.1639344262295, 94.81865284974093%, 62.15686274509804%, 1) 100%)",
        "--plasma-colors-gradient-device": "",
        "--plasma-colors-voice-phrase-gradient": "",
        "--plasma-colors-skeleton-gradient": "linear-gradient( 90deg, rgba(8, 8, 8, 0.09) 0%, rgba(8, 8, 8, 0.08) 6.25%, rgba(8, 8, 8, 0.05) 12.5%, rgba(8, 8, 8, 0.01) 25%, rgba(8, 8, 8, 0.05) 37.5%, rgba(8, 8, 8, 0.08) 43.75%, rgba(8, 8, 8, 0.09) 50%, rgba(8, 8, 8, 0.08) 56.25%, rgba(8, 8, 8, 0.05) 62.5%, rgba(8, 8, 8, 0.01) 75%, rgba(8, 8, 8, 0.05) 87.5%, rgba(8, 8, 8, 0.08) 93.75%, rgba(8, 8, 8, 0.09) 100% )",
        "--plasma-colors-skeleton-gradient-lighter": "linear-gradient( 90deg, rgba(8, 8, 8, 0.36) 0%, rgba(8, 8, 8, 0.32) 6.25%, rgba(8, 8, 8, 0.20) 12.5%, rgba(8, 8, 8, 0.04) 25%, rgba(8, 8, 8, 0.20) 37.5%, rgba(8, 8, 8, 0.32) 43.75%, rgba(8, 8, 8, 0.36) 50%, rgba(8, 8, 8, 0.08) 56.25%, rgba(8, 8, 8, 0.20) 62.5%, rgba(8, 8, 8, 0.04) 75%, rgba(8, 8, 8, 0.20) 87.5%, rgba(8, 8, 8, 0.32) 93.75%, rgba(8, 8, 8, 0.36) 100% )",
        "--plasma-colors-speech-bubble-sent": "",
        "--plasma-colors-speech-bubble-received": "",
        "--plasma-colors-overlay": "rgba(0, 0, 0, 0.8)",
        "--plasma-colors-overlay-soft": "rgba(8, 8, 8, 0.56)",
        "--plasma-colors-overlay-hard": "rgba(8, 8, 8, 0.9)",
        "--plasma-colors-overlay-blur": "rgba(35, 35, 35, 0.2)",
        "--plasma-colors-dark-overlay-soft": "rgba(8, 8, 8, 0.56)",
        "--plasma-colors-dark-overlay-hard": "rgba(8, 8, 8, 0.9)",
        "--plasma-colors-dark-overlay-blur": "rgba(35, 35, 35, 0.2)",
        "--plasma-colors-light-overlay-soft": "rgba(8, 8, 8, 0.56)",
        "--plasma-colors-light-overlay-hard": "rgba(8, 8, 8, 0.9)",
        "--plasma-colors-light-overlay-blur": "rgba(35, 35, 35, 0.2)",
        "--plasma-colors-inverse-overlay-soft": "rgba(8, 8, 8, 0.56)",
        "--plasma-colors-inverse-overlay-hard": "rgba(8, 8, 8, 0.9)",
        "--plasma-colors-inverse-overlay-blur": "rgba(35, 35, 35, 0.2)",
        "--plasma-outline-size": "0.125rem",
        "--plasma-button-l-height": "3.5rem",
        "--plasma-button-l-padding-y": "1rem",
        "--plasma-button-l-padding-x": "1.625rem",
        "--plasma-button-l-padding-content-x": "1.625rem",
        "--plasma-button-l-padding-stretch-x": "1.25rem",
        "--plasma-button-l-radius": "1rem",
        "--plasma-button-l-radius-circle": "1.75rem",
        "--plasma-button-m-height": "3rem",
        "--plasma-button-m-padding-y": "0.75rem",
        "--plasma-button-m-padding-x": "1.375rem",
        "--plasma-button-m-padding-content-x": "1.5rem",
        "--plasma-button-m-padding-stretch-x": "1.25rem",
        "--plasma-button-m-radius": "0.75rem",
        "--plasma-button-m-radius-circle": "1.5rem",
        "--plasma-button-s-height": "2.5rem",
        "--plasma-button-s-padding-y": "0.5rem",
        "--plasma-button-s-padding-x": "1.125rem",
        "--plasma-button-s-padding-content-x": "1.25rem",
        "--plasma-button-s-padding-stretch-x": "1.25rem",
        "--plasma-button-s-radius": "0.75rem",
        "--plasma-button-s-radius-circle": "1.25rem",
        "--plasma-field-helper-text-margin-top": "0.25rem",
        "--plasma-field-helper-text-font-family": "var(--plasma-typo-text-xs-font-family)",
        "--plasma-field-helper-text-font-size": "var(--plasma-typo-text-xs-font-size)",
        "--plasma-field-helper-text-font-style": "var(--plasma-typo-text-xs-font-style)",
        "--plasma-field-helper-text-font-weight": "var(--plasma-typo-text-xs-bold-font-weight)",
        "--plasma-field-helper-text-letter-spacing": "var(--plasma-typo-text-xs-letter-spacing)",
        "--plasma-field-helper-text-line-height": "var(--plasma-typo-text-xs-line-height)",
        "--plasma-field-label-margin-bottom": "0.75rem",
        "--plasma-field-label-color": "var(--plasma-colors-primary)",
        "--plasma-field-content-margin": "1rem",
        "--plasma-input-border-width": "1px",
        "--plasma-input-border-radius": "0.75rem",
        "--plasma-input-l-height": "3rem",
        "--plasma-input-l-padding-y": "0.75rem",
        "--plasma-input-l-padding-x": "1rem",
        "--plasma-input-l-has-label-padding-top": "1.4375rem",
        "--plasma-input-l-has-label-padding-bottom": "0.4375rem",
        "--plasma-input-l-has-content-padding-left": "3.25rem",
        "--plasma-input-l-has-content-padding-right": "3.25rem",
        "--plasma-input-m-height": "2.5rem",
        "--plasma-input-m-padding-y": "0.5rem",
        "--plasma-input-m-padding-x": "1rem",
        "--plasma-input-m-has-content-padding-left": "3.25rem",
        "--plasma-input-m-has-content-padding-right": "3.25rem",
        "--plasma-input-s-height": "2rem",
        "--plasma-input-s-padding-y": "0.25rem",
        "--plasma-input-s-padding-x": "1rem",
        "--plasma-input-s-has-content-padding-left": "3.25rem",
        "--plasma-input-s-has-content-padding-right": "3.25rem",
        "--plasma-input-font-family": "var(--plasma-typo-body-s-font-family)",
        "--plasma-input-font-size": "var(--plasma-typo-body-s-font-size)",
        "--plasma-input-font-style": "var(--plasma-typo-body-s-font-style)",
        "--plasma-input-font-weight": "var(--plasma-typo-body-s-bold-font-weight)",
        "--plasma-input-letter-spacing": "var(--plasma-typo-body-s-letter-spacing)",
        "--plasma-input-line-height": "var(--plasma-typo-body-s-line-height)",
        "--plasma-input-background-color": "var(--plasma-colors-surface-liquid01)",
        "--plasma-input-color": "var(--plasma-colors-primary)",
        "--plasma-input-caret-color": "var(--plasma-colors-primary)",
        "--plasma-input-placeholder-color": "var(--plasma-colors-secondary)",
        "--plasma-input-hover-background-color": "var(--plasma-colors-surface-liquid02)",
        "--plasma-input-focus-background-color": "var(--plasma-colors-surface-liquid02)",
        "--plasma-input-success-background-color": "var(--plasma-colors-background)",
        "--plasma-input-success-color": "var(--plasma-colors-primary)",
        "--plasma-input-success-border-color": "var(--plasma-colors-success)",
        "--plasma-input-warning-background-color": "var(--plasma-colors-background)",
        "--plasma-input-warning-color": "var(--plasma-colors-primary)",
        "--plasma-input-warning-border-color": "var(--plasma-colors-warning)",
        "--plasma-input-error-background-color": "var(--plasma-colors-input-error-background)",
        "--plasma-input-error-color": "var(--plasma-colors-critical)",
        "--plasma-input-error-border-color": "var(--plasma-colors-input-error-border)",
        "--plasma-input-focus-placeholder-color": "var(--plasma-colors-tertiary)",
        "--plasma-input-label-margin-top": "0.4375rem",
        "--plasma-input-label-font-family": "var(--plasma-typo-body-xxs-font-family)",
        "--plasma-input-label-font-size": "var(--plasma-typo-body-xxs-font-size)",
        "--plasma-input-label-font-style": "var(--plasma-typo-body-xxs-font-style)",
        "--plasma-input-label-font-weight": "var(--plasma-typo-body-xxs-bold-font-weight)",
        "--plasma-input-label-letter-spacing": "var(--plasma-typo-body-xxs-letter-spacing)",
        "--plasma-input-label-line-height": "var(--plasma-typo-body-xxs-line-height)",
        "--plasma-input-label-color": "var(--plasma-colors-tertiary)",
        "--plasma-field-font-family": "var(--plasma-typo-body-s-font-family)",
        "--plasma-field-font-size": "var(--plasma-typo-body-s-font-size)",
        "--plasma-field-font-style": "var(--plasma-typo-body-s-font-style)",
        "--plasma-field-font-weight": "var(--plasma-typo-body-s-bold-font-weight)",
        "--plasma-field-letter-spacing": "var(--plasma-typo-body-s-letter-spacing)",
        "--plasma-field-line-height": "var(--plasma-typo-body-s-line-height)",
        "--plasma-field-color": "var(--plasma-colors-secondary)",
        "--plasma-field-success-color": "var(--plasma-colors-success)",
        "--plasma-field-warning-color": "var(--plasma-colors-warning)",
        "--plasma-field-error-color": "var(--plasma-colors-critical)",
        "--text-primary-hover": "#08080893",
        "--text-primary-active": "#080808C4",
        "--text-primary": "rgba(8, 8, 8, 0.96)",
        "--text-primary-brightness": "#171717",
        "--text-secondary-hover": "#080808FF",
        "--text-secondary-active": "#080808AB",
        "--text-secondary": "rgba(8, 8, 8, 0.56)",
        "--text-tertiary-hover": "#080808FF",
        "--text-tertiary-active": "#08080856",
        "--text-tertiary": "rgba(8, 8, 8, 0.28)",
        "--text-paragraph-hover": "#0808087A",
        "--text-paragraph-active": "#080808A3",
        "--text-paragraph": "rgba(8, 8, 8, 0.8)",
        "--text-accent-hover": "#528DFAFF",
        "--text-accent-active": "#075AF2FF",
        "--text-accent": "#2A72F8",
        "--text-accent-gradient-hover": "#000000FF",
        "--text-accent-gradient-active": "#CCCCCCFF",
        "--text-accent-gradient": "linear-gradient(93.97deg, #3E79F0 6.49%, #27C6E5 93.51%)",
        "--text-positive-hover": "#1FC13DFF",
        "--text-positive-active": "#147B27FF",
        "--text-positive": "#1A9E32",
        "--text-warning-hover": "#FB782DFF",
        "--text-warning-active": "#D25004FF",
        "--text-warning": "#FA5F05",
        "--text-negative-hover": "#F54254FF",
        "--text-negative-active": "#DA0B20FF",
        "--text-negative": "#F31B31",
        "--on-dark-text-primary-hover": "#FFFFFF93",
        "--on-dark-text-primary-active": "#FFFFFFC4",
        "--on-dark-text-primary": "rgba(255, 255, 255, 0.96)",
        "--on-dark-text-primary-brightness": "#FFFFFF",
        "--on-dark-text-secondary-hover": "#FFFFFFFF",
        "--on-dark-text-secondary-active": "#FFFFFFAB",
        "--on-dark-text-secondary": "rgba(255, 255, 255, 0.56)",
        "--on-dark-text-tertiary-hover": "#FFFFFFFF",
        "--on-dark-text-tertiary-active": "#FFFFFF56",
        "--on-dark-text-tertiary": "rgba(255, 255, 255, 0.28)",
        "--on-dark-text-paragraph-hover": "#FFFFFF7A",
        "--on-dark-text-paragraph-active": "#FFFFFFA3",
        "--on-dark-text-paragraph": "rgba(255, 255, 255, 0.8)",
        "--on-dark-text-accent-hover": "#689CFDFF",
        "--on-dark-text-accent-active": "#1767FDFF",
        "--on-dark-text-accent": "#3F81FD",
        "--on-dark-text-accent-gradient-hover": "#000000FF",
        "--on-dark-text-accent-gradient-active": "#CCCCCCFF",
        "--on-dark-text-accent-gradient": "linear-gradient(89.83deg, #5E94FF 0%, #43DBFA 100%)",
        "--on-dark-text-positive-hover": "#1FC13DFF",
        "--on-dark-text-positive-active": "#147B27FF",
        "--on-dark-text-positive": "#1A9E32",
        "--on-dark-text-warning-hover": "#FB782DFF",
        "--on-dark-text-warning-active": "#D25004FF",
        "--on-dark-text-warning": "#FA5F05",
        "--on-dark-text-negative-hover": "#FF5263FF",
        "--on-dark-text-negative-active": "#FF001AFF",
        "--on-dark-text-negative": "#FF293E",
        "--on-light-text-primary-hover": "#08080893",
        "--on-light-text-primary-active": "#080808C4",
        "--on-light-text-primary": "rgba(8, 8, 8, 0.96)",
        "--on-light-text-primary-brightness": "#171717",
        "--on-light-text-secondary-hover": "#080808FF",
        "--on-light-text-secondary-active": "#080808AB",
        "--on-light-text-secondary": "rgba(8, 8, 8, 0.56)",
        "--on-light-text-tertiary-hover": "#080808FF",
        "--on-light-text-tertiary-active": "#08080856",
        "--on-light-text-tertiary": "rgba(8, 8, 8, 0.28)",
        "--on-light-text-paragraph-hover": "#0808087A",
        "--on-light-text-paragraph-active": "#080808A3",
        "--on-light-text-paragraph": "rgba(8, 8, 8, 0.8)",
        "--on-light-text-accent-hover": "#528DFAFF",
        "--on-light-text-accent-active": "#075AF2FF",
        "--on-light-text-accent": "#2A72F8",
        "--on-light-text-accent-gradient-hover": "#000000FF",
        "--on-light-text-accent-gradient-active": "#CCCCCCFF",
        "--on-light-text-accent-gradient": "linear-gradient(93.97deg, #3E79F0 6.49%, #27C6E5 93.51%)",
        "--on-light-text-positive-hover": "#1FC13DFF",
        "--on-light-text-positive-active": "#147B27FF",
        "--on-light-text-positive": "#1A9E32",
        "--on-light-text-warning-hover": "#FB782DFF",
        "--on-light-text-warning-active": "#D25004FF",
        "--on-light-text-warning": "#FA5F05",
        "--on-light-text-negative-hover": "#F54254FF",
        "--on-light-text-negative-active": "#DA0B20FF",
        "--on-light-text-negative": "#F31B31",
        "--inverse-text-primary-hover": "#FFFFFF93",
        "--inverse-text-primary-active": "#FFFFFFC4",
        "--inverse-text-primary": "rgba(255, 255, 255, 0.96)",
        "--inverse-text-primary-brightness": "#FFFFFF",
        "--inverse-text-secondary-hover": "#FFFFFFFF",
        "--inverse-text-secondary-active": "#FFFFFFAB",
        "--inverse-text-secondary": "rgba(255, 255, 255, 0.56)",
        "--inverse-text-tertiary-hover": "#FFFFFFFF",
        "--inverse-text-tertiary-active": "#FFFFFF56",
        "--inverse-text-tertiary": "rgba(255, 255, 255, 0.28)",
        "--inverse-text-paragraph-hover": "#FFFFFF7A",
        "--inverse-text-paragraph-active": "#FFFFFFA3",
        "--inverse-text-paragraph": "rgba(255, 255, 255, 0.8)",
        "--surface-solid-primary-hover": "#FAFAFAFF",
        "--surface-solid-primary-active": "#F0F0F0FF",
        "--surface-solid-primary": "#F5F5F5",
        "--surface-solid-primary-brightness": "#F6F6F6",
        "--surface-solid-secondary-hover": "#F7F7F7FF",
        "--surface-solid-secondary-active": "#E8E8E8FF",
        "--surface-solid-secondary": "#ECECEC",
        "--surface-solid-tertiary-hover": "#EDEDEDFF",
        "--surface-solid-tertiary-active": "#D4D4D4FF",
        "--surface-solid-tertiary": "#DDDDDD",
        "--surface-solid-card-hover": "#FFFFFFFF",
        "--surface-solid-card-active": "#FFFFFFFF",
        "--surface-solid-card": "rgba(255, 255, 255, 1)",
        "--surface-solid-card-brightness": "#FFFFFF",
        "--surface-solid-default-hover": "#262626FF",
        "--surface-solid-default-active": "#030303FF",
        "--surface-solid-default": "#080808",
        "--surface-transparent-primary-hover": "#08080803",
        "--surface-transparent-primary-active": "#0808080D",
        "--surface-transparent-primary": "rgba(8, 8, 8, 0.03)",
        "--surface-transparent-secondary-hover": "#08080805",
        "--surface-transparent-secondary-active": "#0808081A",
        "--surface-transparent-secondary": "rgba(8, 8, 8, 0.06)",
        "--surface-transparent-tertiary-hover": "#0808080A",
        "--surface-transparent-tertiary-active": "#08080829",
        "--surface-transparent-tertiary": "rgba(8, 8, 8, 0.12)",
        "--surface-transparent-deep-hover": "#0808088F",
        "--surface-transparent-deep-active": "#080808AD",
        "--surface-transparent-deep": "rgba(8, 8, 8, 0.64)",
        "--surface-transparent-card-hover": "#FFFFFFFF",
        "--surface-transparent-card-active": "#FFFFFFFF",
        "--surface-transparent-card": "rgba(255, 255, 255, 1)",
        "--surface-transparent-card-brightness": "#FFFFFF",
        "--surface-clear-hover": "#FFFFFF00",
        "--surface-clear-active": "#FFFFFF00",
        "--surface-clear": "rgba(255, 255, 255, 0)",
        "--surface-accent-hover": "#528DFAFF",
        "--surface-accent-active": "#1665F8FF",
        "--surface-accent": "#2A72F8",
        "--surface-accent-gradient-hover": "#FFFFFFFF",
        "--surface-accent-gradient-active": "#FFFFFFFF",
        "--surface-accent-gradient": "linear-gradient(93.97deg, #3E79F0 6.49%, #27C6E5 93.51%)",
        "--surface-transparent-accent-hover": "#2A72F805",
        "--surface-transparent-accent-active": "#2A72F81A",
        "--surface-positive-hover": "#1EB83AFF",
        "--surface-positive-active": "#178C2CFF",
        "--surface-positive": "#1A9E32",
        "--surface-warning-hover": "#FB782DFF",
        "--surface-warning-active": "#E65705FF",
        "--surface-warning": "#FA5F05",
        "--surface-negative-hover": "#F54254FF",
        "--surface-negative-active": "#ED0C23FF",
        "--surface-negative": "#F31B31",
        "--surface-transparent-positive-hover": "#1A9E3205",
        "--surface-transparent-positive-active": "#1A9E321A",
        "--surface-transparent-warning-hover": "#FA5F0505",
        "--surface-transparent-warning-active": "#FA5F051A",
        "--surface-transparent-negative-hover": "#F31B3105",
        "--surface-transparent-negative-active": "#F31B311A",
        "--surface-transparent-accent": "rgba(42,114,248,0.06)",
        "--surface-transparent-positive": "rgba(26,158,50,0.06)",
        "--surface-transparent-warning": "rgba(250,95,5,0.06)",
        "--surface-transparent-negative": "rgba(243,27,49,0.06)",
        "--on-dark-surface-solid-primary-hover": "#363636FF",
        "--on-dark-surface-solid-primary-active": "#0D0D0DFF",
        "--on-dark-surface-solid-primary": "#171717",
        "--on-dark-surface-solid-primary-brightness": "#252525",
        "--on-dark-surface-solid-secondary-hover": "#3B3B3BFF",
        "--on-dark-surface-solid-secondary-active": "#1C1C1CFF",
        "--on-dark-surface-solid-secondary": "#262626",
        "--on-dark-surface-solid-tertiary-hover": "#4A4A4AFF",
        "--on-dark-surface-solid-tertiary-active": "#2B2B2BFF",
        "--on-dark-surface-solid-tertiary": "#363636",
        "--on-dark-surface-solid-card-hover": "#363636FF",
        "--on-dark-surface-solid-card-active": "#0D0D0DFF",
        "--on-dark-surface-solid-card": "#171717",
        "--on-dark-surface-solid-card-brightness": "#252525",
        "--on-dark-surface-solid-default-hover": "#FFFFFFFF",
        "--on-dark-surface-solid-default-active": "#FFFFFFFF",
        "--on-dark-surface-solid-default": "rgba(255, 255, 255, 1)",
        "--on-dark-surface-transparent-primary-hover": "#363636FF",
        "--on-dark-surface-transparent-primary-active": "#0D0D0DFF",
        "--on-dark-surface-transparent-primary": "#171717",
        "--on-dark-surface-transparent-secondary-hover": "#3B3B3BFF",
        "--on-dark-surface-transparent-secondary-active": "#1C1C1CFF",
        "--on-dark-surface-transparent-secondary": "#262626",
        "--on-dark-surface-transparent-tertiary-hover": "#4A4A4AFF",
        "--on-dark-surface-transparent-tertiary-active": "#2B2B2BFF",
        "--on-dark-surface-transparent-tertiary": "#363636",
        "--on-dark-surface-transparent-deep-hover": "#FFFFFF8F",
        "--on-dark-surface-transparent-deep-active": "#FFFFFFAD",
        "--on-dark-surface-transparent-deep": "rgba(255, 255, 255, 0.64)",
        "--on-dark-surface-transparent-card-hover": "#FFFFFF0A",
        "--on-dark-surface-transparent-card-active": "#FFFFFF29",
        "--on-dark-surface-transparent-card": "rgba(255, 255, 255, 0.12)",
        "--on-dark-surface-transparent-card-brightness": "#FFFFFF",
        "--on-dark-surface-accent-hover": "#689CFDFF",
        "--on-dark-surface-accent-active": "#2B74FDFF",
        "--on-dark-surface-accent": "#3F81FD",
        "--on-dark-surface-accent-gradient-hover": "#FFFFFFFF",
        "--on-dark-surface-accent-gradient-active": "#FFFFFFFF",
        "--on-dark-surface-accent-gradient": "linear-gradient(93.97deg, #3E79F0 6.49%, #27C6E5 93.51%)",
        "--on-dark-surface-positive-hover": "#1EB83AFF",
        "--on-dark-surface-positive-active": "#178C2CFF",
        "--on-dark-surface-positive": "#1A9E32",
        "--on-dark-surface-warning-hover": "#FB782DFF",
        "--on-dark-surface-warning-active": "#E65705FF",
        "--on-dark-surface-warning": "#FA5F05",
        "--on-dark-surface-negative-hover": "#FF5263FF",
        "--on-dark-surface-negative-active": "#FF142CFF",
        "--on-dark-surface-negative": "#FF293E",
        "--on-light-surface-solid-primary-hover": "#FAFAFAFF",
        "--on-light-surface-solid-primary-active": "#F0F0F0FF",
        "--on-light-surface-solid-primary": "#F5F5F5",
        "--on-light-surface-solid-primary-brightness": "#F6F6F6",
        "--on-light-surface-solid-secondary-hover": "#F7F7F7FF",
        "--on-light-surface-solid-secondary-active": "#E8E8E8FF",
        "--on-light-surface-solid-secondary": "#ECECEC",
        "--on-light-surface-solid-tertiary-hover": "#EDEDEDFF",
        "--on-light-surface-solid-tertiary-active": "#D4D4D4FF",
        "--on-light-surface-solid-tertiary": "#DDDDDD",
        "--on-light-surface-solid-card-hover": "#FFFFFFFF",
        "--on-light-surface-solid-card-active": "#FFFFFFFF",
        "--on-light-surface-solid-card": "rgba(255, 255, 255, 1)",
        "--on-light-surface-solid-card-brightness": "#FFFFFF",
        "--on-light-surface-solid-default-hover": "#262626FF",
        "--on-light-surface-solid-default-active": "#030303FF",
        "--on-light-surface-solid-default": "#080808",
        "--on-light-surface-transparent-primary-hover": "#08080803",
        "--on-light-surface-transparent-primary-active": "#0808080D",
        "--on-light-surface-transparent-primary": "rgba(8, 8, 8, 0.03)",
        "--on-light-surface-transparent-secondary-hover": "#08080805",
        "--on-light-surface-transparent-secondary-active": "#0808081A",
        "--on-light-surface-transparent-secondary": "rgba(8, 8, 8, 0.06)",
        "--on-light-surface-transparent-tertiary-hover": "#0808080A",
        "--on-light-surface-transparent-tertiary-active": "#08080829",
        "--on-light-surface-transparent-tertiary": "rgba(8, 8, 8, 0.12)",
        "--on-light-surface-transparent-deep-hover": "#0808088F",
        "--on-light-surface-transparent-deep-active": "#080808AD",
        "--on-light-surface-transparent-deep": "rgba(8, 8, 8, 0.64)",
        "--on-light-surface-transparent-card-hover": "#FFFFFFFF",
        "--on-light-surface-transparent-card-active": "#FFFFFFFF",
        "--on-light-surface-transparent-card": "rgba(255, 255, 255, 1)",
        "--on-light-surface-transparent-card-brightness": "#FFFFFF",
        "--on-light-surface-accent-hover": "#528DFAFF",
        "--on-light-surface-accent-active": "#1665F8FF",
        "--on-light-surface-accent": "#2A72F8",
        "--on-light-surface-accent-gradient-hover": "#FFFFFFFF",
        "--on-light-surface-accent-gradient-active": "#FFFFFFFF",
        "--on-light-surface-accent-gradient": "linear-gradient(93.97deg, #3E79F0 6.49%, #27C6E5 93.51%)",
        "--on-light-surface-positive-hover": "#1EB83AFF",
        "--on-light-surface-positive-active": "#178C2CFF",
        "--on-light-surface-positive": "#1A9E32",
        "--on-light-surface-warning-hover": "#FB782DFF",
        "--on-light-surface-warning-active": "#E65705FF",
        "--on-light-surface-warning": "#FA5F05",
        "--on-light-surface-negative-hover": "#F54254FF",
        "--on-light-surface-negative-active": "#ED0C23FF",
        "--on-light-surface-negative": "#F31B31",
        "--background-primary": "#F9F9F9",
        "--background-primary-brightness": "#F9F9F9",
        "--dark-background-primary": "#080808",
        "--light-background-primary": "#F9F9F9",
        "--overlay-soft": "rgba(249, 249, 249, 0.56)",
        "--overlay-hard": "rgba(249, 249, 249, 0.96)",
        "--overlay-blur": "rgba(249, 249, 249, 0.28)",
        "--on-dark-overlay-soft": "rgba(8, 8, 8, 0.56)",
        "--on-dark-overlay-hard": "rgba(8, 8, 8, 0.96)",
        "--on-dark-overlay-blur": "rgba(8, 8, 8, 0.28)",
        "--on-light-overlay-soft": "rgba(249, 249, 249, 0.56)",
        "--on-light-overlay-hard": "rgba(249, 249, 249, 0.96)",
        "--on-light-overlay-blur": "rgba(249, 249, 249, 0.28)",
        "--skeleton-gradient": "linear-gradient( 90deg, rgba(8, 8, 8, 0.09) 0%, rgba(8, 8, 8, 0.08) 6.25%, rgba(8, 8, 8, 0.05) 12.5%, rgba(8, 8, 8, 0.01) 25%, rgba(8, 8, 8, 0.05) 37.5%, rgba(8, 8, 8, 0.08) 43.75%, rgba(8, 8, 8, 0.09) 50%, rgba(8, 8, 8, 0.08) 56.25%, rgba(8, 8, 8, 0.05) 62.5%, rgba(8, 8, 8, 0.01) 75%, rgba(8, 8, 8, 0.05) 87.5%, rgba(8, 8, 8, 0.08) 93.75%, rgba(8, 8, 8, 0.09) 100% )",
        "--skeleton-gradient-lighter": "linear-gradient( 90deg, rgba(8, 8, 8, 0.36) 0%, rgba(8, 8, 8, 0.32) 6.25%, rgba(8, 8, 8, 0.20) 12.5%, rgba(8, 8, 8, 0.04) 25%, rgba(8, 8, 8, 0.20) 37.5%, rgba(8, 8, 8, 0.32) 43.75%, rgba(8, 8, 8, 0.36) 50%, rgba(8, 8, 8, 0.08) 56.25%, rgba(8, 8, 8, 0.20) 62.5%, rgba(8, 8, 8, 0.04) 75%, rgba(8, 8, 8, 0.20) 87.5%, rgba(8, 8, 8, 0.32) 93.75%, rgba(8, 8, 8, 0.36) 100% )",
        "--outline-solid-secondary": "#949494",
        "--outline-solid-secondary-hover": "#A3A3A3FF",
        "--outline-accent": "#2A72F8",
        "--text-info": "#3F81FD",
        "--surface-transparent-info": "#2A72F81F",
        "color": "#080808",
        "backgroundColor": "#FFFFFF"
    }
};
//# sourceMappingURL=light.js.map